const IMAGES = [
  {
    url: "https://static.prod-images.emergentagent.com/jobs/9c39dd25-bc0f-419c-a6ee-60a4c93dfd8b/images/da3f92eb2e712dafa76dc37c816a8a3607903f13f0f8e351b716ca51717bd5b5.png",
    label: "Legal Basement Suite",
    category: "Basement",
    span: "lg:col-span-2 lg:row-span-2",
  },
  {
    url: "https://images.unsplash.com/photo-1682888813913-e13f18692019?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBraXRjaGVuJTIwcmVtb2RlbHxlbnwwfHx8fDE3NzkxMzQ4MzZ8MA&ixlib=rb-4.1.0&q=85",
    label: "Kitchen Remodel",
    category: "Kitchen",
  },
  {
    url: "https://images.unsplash.com/photo-1638799869566-b17fa794c4de?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBiYXRocm9vbSUyMHJlbW9kZWx8ZW58MHx8fHwxNzc5MTM0ODM2fDA&ixlib=rb-4.1.0&q=85",
    label: "Modern Washroom",
    category: "Bath",
  },
  {
    url: "https://static.prod-images.emergentagent.com/jobs/9c39dd25-bc0f-419c-a6ee-60a4c93dfd8b/images/ebbb87324191b0c2940c8e85e41e49198cb0f03d2314f6b9b0de069be3b43868.png",
    label: "Hardwood Flooring",
    category: "Flooring",
  },
  {
    url: "https://static.prod-images.emergentagent.com/jobs/9c39dd25-bc0f-419c-a6ee-60a4c93dfd8b/images/5693d252febbebc441119d363e18fbf86b24d90e579c8035baa8c64cd384d2dd.png",
    label: "Interior Painting",
    category: "Painting",
  },
];

export default function Gallery() {
  return (
    <section id="gallery" className="py-24 lg:py-36 bg-[#FAF7F2]" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 mb-16 lg:mb-20 items-end">
          <div className="lg:col-span-8">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-10 h-px bg-[#B08D5B]" />
              <span className="label-overline text-[10px] text-[#B08D5B]">Selected Work</span>
            </div>
            <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight font-light text-[#0B1B33] leading-[1.05]">
              Projects we're <span className="italic text-[#B08D5B]">proud</span> of.
            </h2>
          </div>
          <div className="lg:col-span-4 lg:text-right">
            <a
              href="#contact"
              className="inline-flex items-center gap-2 label-overline text-[11px] text-[#0B1B33] hover:text-[#B08D5B] transition-colors"
              data-testid="gallery-cta-link"
            >
              Start your project
              <span className="text-base">→</span>
            </a>
          </div>
        </div>

        <div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 auto-rows-[220px] gap-4"
          data-testid="gallery-grid"
        >
          {IMAGES.map((img, i) => (
            <figure
              key={i}
              className={`relative overflow-hidden group bg-[#EDE6D8] ${img.span || ""}`}
              data-testid={`gallery-item-${i}`}
            >
              <img
                src={img.url}
                alt={img.label}
                className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B1B33]/85 via-[#0B1B33]/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <figcaption className="absolute bottom-0 left-0 right-0 p-5 text-white opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">
                <div className="label-overline text-[9px] text-[#D4B888] mb-1.5">
                  {img.category}
                </div>
                <div className="font-heading text-lg lg:text-xl font-medium">{img.label}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
